enum InteractionType {
  CLICK_PREVIOUS = 'Click Previous',
  CLICK_NEXT = 'Click Next',
  EXPAND_ABOUT = 'Expand About the Class',
  EXPAND_FAQ = 'Expand FAQ',
  GIFT_BUTTON_CLICK = 'Gift Button Click',
  GIFT_LINK_COPY = 'Gift Link Copy',
  PRINT_BUTTON_CLICK = 'Print Button Click',
  ASK_ATK_BUTTON_CLICK = 'Click Open Ask ATK',
  VIEW_ASK_ATK_MODAL = 'View Ask ATK Modal',
  VIEW_STEP = 'View Step',
  SUBMIT = 'Submit',
  OPEN_DOCUMENT = 'Open Document',
  MADE_RECIPE = 'Made Recipe',
}

export default InteractionType;
